<template>
    <div class="hooper">
        <hooper :settings="hooperSettings" v-if="items.length > 0">
            <slide v-for="(item, index) in items" :key="index">
                <img :src="item.image" alt="slide image" @click="showPreview(index)" />
            </slide>
            <hooper-navigation slot="hooper-addons"></hooper-navigation>
            <hooper-pagination slot="hooper-addons"></hooper-pagination>
        </hooper>
        <div v-if="showPreviewModal" class="preview-modal" @click.self="closePreview">
            <img :src="items[previewIndex].full"  @click.self="closePreview" />
            <button @click="closePreview">X</button>
        </div>
    </div>
</template>
  
<script>
import {
    Hooper,
    Slide,
    Pagination as HooperPagination,
    Navigation as HooperNavigation
} from 'hooper';

import 'hooper/dist/hooper.css';

export default {
    name: 'AppHooperImageSlider',
    components: {
        Hooper,
        Slide,
        HooperPagination,
        HooperNavigation
    },
    props: {
        images: {
            type: Array,
            default: () => {
                return []
            }
        }
    },
    data() {
        const baseUrl = process.env.VUE_APP_API_BASE_URL;
        const newFormatArray = this.images.map((item) => {
            let relPath = item.path.startsWith('/') ? item.path.substring(1) : item.path;
            if (relPath.startsWith('storage/app/')) {
                relPath = relPath.substring('storage/app/'.length);
            }
            return {
                id: item.id,
                image: `${baseUrl}/image/compact/${relPath}`,
                full: `${baseUrl}/image/compact/${relPath}`,
            };
        });

        return {
            items: newFormatArray,
            hooperSettings: {
                itemsToShow: 1,
                wheelControl: false,
                mouseDrag: true,
                touchDrag: true,
                pullDrag: true,
            },
            showPreviewModal: false,
            previewIndex: null,
        };
    },
    methods: {
        showPreview(index) {
            this.showPreviewModal = true;
            this.previewIndex = index;
        },
        closePreview() {
            this.showPreviewModal = false;
            this.previewIndex = null;
        },
    },
};
</script>
<style lang="scss" scoped>
.hooper {
    height: auto;
    
    img {
        max-width: 300px;
        max-height: 300px;
        object-fit: cover;
        width: 100%;
        height: auto;
        display: block;
        margin: 0 auto;
    }
}
.preview-modal {
  position: fixed;
  top: 45px;
  left: 0;
  width: 100%;
  height: 100%;
  background-color: rgba(0, 0, 0, 0.8);
  display: flex;
  justify-content: center;
  align-items: center;
}

.preview-modal img {
  max-width: 80%;
  max-height: 80%;
  object-fit: contain;
}

.preview-modal button {
  position: absolute;
  top: 55px;
  right: 10%;
  padding: 10px;
  font-size: 16px;
  color: white;
  background-color: rgba(255, 0, 0, 0.5);
  border: none;
  cursor: pointer;
}

</style>
